import { useEffect, useState } from 'react'
import { displayTable } from '../utils/tableLabel'
import type { WaitingTable } from './useMyWaiting'

/** Hatırlatma eşikleri, dakika. */
const STEPS = [10, 20]
/** Şerit bu kadar sonra kayboluyor (kullanıcı, 20 Eki 2026: 5 sn). */
const SHOW_MS = 5000

/**
 * Gösterilmiş uyarılar, sayfa değişse ve yenilense de hatırlanıyor (20 Eki
 * 2026). Eskiden bileşenle birlikte sıfırlanıyordu: garson her sayfa
 * değiştirdiğinde 10 dakikayı geçmiş bütün ürünler için şerit yeniden
 * çıkıyor, ekrandan hiç gitmiyormuş gibi görünüyordu.
 */
const SEEN_KEY = 'adissoo.waitAlertsSeen'
const seenKeys: Set<string> = (() => {
  try {
    const raw = sessionStorage.getItem(SEEN_KEY)
    return new Set(raw ? (JSON.parse(raw) as string[]) : [])
  } catch {
    return new Set()
  }
})()
function rememberSeen(key: string): void {
  seenKeys.add(key)
  try {
    // Sınırlı: bir servis boyunca birkaç yüz uyarıdan fazlası olmaz.
    sessionStorage.setItem(SEEN_KEY, JSON.stringify([...seenKeys].slice(-500)))
  } catch {
    // Gizli pencere: bu oturumda bellekte kalıyor, yeter.
  }
}

/**
 * Sipariş Takip hatırlatması: bir ürün 10. ve 20. dakikayı geçince bir kez,
 * ekranın üstünde kısa bir satır. Her eşik her ürün için yalnızca bir kez,
 * götürülmüş ürün listeden düştüğü için bir daha hiç.
 *
 * Aynı anda birden fazla ürün eşiği geçerse tek satırda toplanıyor.
 */
export function useWaitAlerts(on: boolean, tables: WaitingTable[], now: number): string | null {
  const [text, setText] = useState<string | null>(null)

  useEffect(() => {
    if (!on) return
    const fresh: string[] = []
    for (const { ticket, lines } of tables) {
      for (const { line, since } of lines) {
        const mins = (now - since) / 60_000
        const step = [...STEPS].reverse().find((s) => mins >= s)
        if (!step) continue
        const key = `${ticket.id}|${line.productId}|${line.note ?? ''}|${since}|${step}`
        if (seenKeys.has(key)) continue
        rememberSeen(key)
        fresh.push(`${displayTable(ticket.tableName) ?? 'Adisyon'}: ${line.name} ${step} dakikadır bekliyor`)
      }
    }
    if (fresh.length === 0) return
    setText(fresh.length === 1 ? fresh[0] : `${fresh[0]} ve ${fresh.length - 1} ürün daha`)
  }, [on, tables, now])

  // Kapanma sayacı yalnızca yazıya bağlı. Eskiden yukarıdaki etkinin içindeydi:
  // liste her güncellendiğinde (süreler 30 sn'de bir ilerliyor) sayaç
  // temizleniyor ama yeniden kurulmuyordu, şerit ekranda kalıyordu.
  useEffect(() => {
    if (!text) return
    const t = window.setTimeout(() => setText(null), SHOW_MS)
    return () => window.clearTimeout(t)
  }, [text])

  return on ? text : null
}
